// @flow

import React from "react"
import styled from "styled-components"

type Props = {
  children: Object,
  bold?: boolean,
  style?: Object
}

const StyledHeader = styled.h3`
  color: black;
  display: inline-block;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  font-weight: ${p => p.$bold && "bold"};
  letter-spacing: normal;
  line-height: normal;
  padding: 0px;
`

const TitleSecondary = ({
  children,
  bold = false,
  ...rest
}: Props): React$Element<any> => {
  return (
    <StyledHeader {...rest} $bold={bold}>
      {children}
    </StyledHeader>
  )
}

export default TitleSecondary
